<template>
  <div class="contact-box">
    <OrganismsLayoutsContactBoxTel />

    <div class="contact-item contact-item_web">
      <div class="contact-item_head">
        <div class="contact-item_icon">
          <img src="/image/contact-icon_web.png" alt="" />
        </div>
        <p class="contact-item_title">ウェブからのお問い合わせ</p>
      </div>
      <p class="contact-web_text">
        ご意見、ご質問など些細なことでも、<br class="sp-only" />お気軽にお問い合せください。
      </p>
      <div class="contact-web_btn-area">
        <NuxtLink to="/contact" class="contact-web_btn">
          お問い合わせフォームへ<span class="contact-web_arrow"></span>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `contact-box`。ハンバーガーメニュー内と `sec_footer-contact` の両方で使う。
 * 電話の1枚はログイン画面でも単体で使うので `tel.vue` に分けてある。
 */
</script>
